<div *ngFor="let table of tables;let i = index">
    <div class="property-details-container" [ngClass]="{ 'mt-3': i > 0 }">
        <label *ngIf="table.title">{{ table.title }}</label>
        <div class="property-details-table">

            <div>
                <table class="table table-bordered" style="border-collapse: collapse; width: 100%; margin: 0;">
                    <tbody *ngIf="table.columns && table.columns.length">
                        <tr
                            *ngFor="let i of array(Math.ceil(table.columns.length / columnsPerRow)).fill(0);  let rowIndex = index">
                            <ng-container *ngFor="let j of [].constructor(columnsPerRow); let colIndex = index">

                                <td *ngIf="table.columns[rowIndex * columnsPerRow + colIndex]"
                                    style="border: 1px solid black; padding: 10px; background-color: #f3e8ff99; 
                        font-weight: bold; text-align: left; min-width: 175px; white-space: nowrap;overflow: hidden; text-overflow: ellipsis;">
                                    {{ table.columns[rowIndex * columnsPerRow + colIndex].name }}
                                </td>

                                <td *ngIf="table.data && table.data.length > 0 && table.columns[rowIndex * columnsPerRow + colIndex]"
                                    style="border: 1px solid black; padding: 10px; min-width: 175px;
                        overflow: hidden; text-overflow: ellipsis; white-space: nowrap; max-width:255px;
                        " [attr.title]="table.data[0][table.columns[rowIndex * columnsPerRow + colIndex]?.field]">

                                    <ng-container *ngIf="isEditMode">

                                        <ng-container
                                            [ngSwitch]="table.columns[rowIndex * columnsPerRow + colIndex]?.type">
                                            <select *ngSwitchCase="'boolean'"
                                                [(ngModel)]="table.data[0][table.columns[rowIndex * columnsPerRow + colIndex]?.field]"
                                                class="clr-input"
                                                (ngModelChange)="validateField(table.columns,table.columns[rowIndex * columnsPerRow + colIndex]?.field, table.columns[rowIndex * columnsPerRow + colIndex]?.type,0,table.data[0])">
                                                <option [value]="true">True</option>
                                                <option [value]="false">False</option>
                                            </select>

                                            <textarea *ngSwitchCase="'custom'"
                                                [(ngModel)]="table.data[0][table.table.columns[rowIndex * columnsPerRow + colIndex]?.field]"
                                                class="clr-input"
                                                (ngModelChange)="validateField(table.columns,table.columns[rowIndex * columnsPerRow + colIndex]?.field, table.columns[rowIndex * columnsPerRow + colIndex]?.type,0,table.data[0])">
                                </textarea>

                                            <select *ngSwitchCase="'select'"
                                                [(ngModel)]="table.data[0][table.columns[rowIndex * columnsPerRow + colIndex]?.field]"
                                                class="clr-input"
                                                (ngModelChange)="validateField(table.columns,table.columns[rowIndex * columnsPerRow + colIndex]?.field, table.columns[rowIndex * columnsPerRow + colIndex]?.type,0,table.data[0])">
                                                <option
                                                    *ngFor="let option of table.columns[rowIndex * columnsPerRow + colIndex]?.options"
                                                    [value]="option.value">{{ option.label }}
                                                </option>
                                            </select>

                                            <input *ngSwitchDefault
                                                [(ngModel)]="table.data[0][table.columns[rowIndex * columnsPerRow + colIndex]?.field]"
                                                [type]="table.columns[rowIndex * columnsPerRow + colIndex]?.type || 'text'"
                                                class="clr-input"
                                                (ngModelChange)="validateField(table.columns,table.columns[rowIndex * columnsPerRow + colIndex]?.field, table.columns[rowIndex * columnsPerRow + colIndex]?.type,0,table.data[0])" />
                                        </ng-container>
                                        <div *ngIf="errors && errors[0] && errors[0][table.columns[rowIndex * columnsPerRow + colIndex]?.field]"
                                            class="error-message" style="margin-left: 1.2em;">
                                            {{ errors[0][table.columns[rowIndex * columnsPerRow + colIndex]?.field] }}
                                        </div>
                                    </ng-container>

                                    <ng-container *ngIf="!isEditMode && table.data.length">
                                        <ng-container
                                            *ngIf="table.columns[rowIndex * columnsPerRow + colIndex].unit === 'percentage'">
                                            {{ table.data[0][table.columns[rowIndex * columnsPerRow + colIndex].field] ?
                                            (table.data[0][table.columns[rowIndex * columnsPerRow + colIndex].field] |
                                            number:'1.2-2') + '%' :
                                            'N/A' }}
                                        </ng-container>
                                        <ng-container
                                            *ngIf="table.columns[rowIndex * columnsPerRow + colIndex].unit === 'currency'">
                                            {{formatCurrency(table.data[0][table.columns[rowIndex * columnsPerRow +
                                            colIndex].field])}}
                                        </ng-container>

                                        <ng-container
                                            *ngIf="table.columns[rowIndex * columnsPerRow + colIndex].unit === 'distance'">
                                            {{ table.data[0][table.columns[rowIndex * columnsPerRow + colIndex].field] ?
                                            table.data[0][table.columns[rowIndex * columnsPerRow + colIndex].field] + '
                                            ' +
                                            table.data[0][table.columns[rowIndex * columnsPerRow + colIndex].subunit]
                                            :'N/A' }}
                                        </ng-container>

                                        <ng-container *ngIf="!table.columns[rowIndex * columnsPerRow + colIndex].unit">
                                            <ng-container
                                                *ngIf="table.columns[rowIndex * columnsPerRow + colIndex].type === 'number'">
                                                {{ formatNumber(table.data[0][table.columns[rowIndex * columnsPerRow +
                                                colIndex].field]) || 'N/A' }}
                                            </ng-container>
                                            <ng-container
                                                *ngIf="table.columns[rowIndex * columnsPerRow + colIndex].type === 'date'">
                                                {{ table.data[0][table.columns[rowIndex * columnsPerRow +
                                                colIndex].field] ?
                                                (table.data[0][table.columns[rowIndex * columnsPerRow + colIndex].field]
                                                | date:'MM/dd/yyyy') :
                                                'N/A' }}
                                            </ng-container>
                                            <ng-container
                                                *ngIf="table.columns[rowIndex * columnsPerRow + colIndex].type === 'text'">
                                                {{ table.data[0][table.columns[rowIndex * columnsPerRow +
                                                colIndex].field] || 'N/A' }}
                                            </ng-container>

                                            <ng-container
                                                *ngIf="table.columns[rowIndex * columnsPerRow + colIndex].type === 'boolean'">
                                                {{ table.data[0][table.columns[rowIndex * columnsPerRow +
                                                colIndex].field] ? 'Yes':'No' }}
                                            </ng-container>


                                            <ng-container
                                                *ngIf="table.columns[rowIndex * columnsPerRow + colIndex].type === 'custom'">
                                                <div
                                                    [innerHTML]="renderCell({'field': table.columns[rowIndex * columnsPerRow + colIndex].field, 'data': table.data[0]})">
                                                </div>
                                            </ng-container>
                                        </ng-container>
                                    </ng-container>
                                </td>
                            </ng-container>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>



<!-- Table view modal -->
<div class="setting-modal">
    <clr-modal [(clrModalOpen)]="isSettingsOpen" class="setting-modal">
        <h3 class="modal-title">
            <clr-icon shape="settings" class="me-2"></clr-icon> Table Settings
        </h3>
        <div class="modal-body">
            <clr-tabs>
                <clr-tab>
                    <button clrTabLink>Columns</button>
                    <clr-tab-content clrTabContentActive>
                        <div class="dropdown w-100">
                            <ul class="columns-list mt-2">
                                <li *ngFor="let col of columnsCopy">
                                    <div class="d-flex">
                                        <input type="checkbox" style="margin:0px 10px;" [(ngModel)]="col.visible">
                                        <label class="form-check-label" style="margin:0px 10px;">{{ col.name }}</label>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </clr-tab-content>
                </clr-tab>

            </clr-tabs>
        </div>

        <!-- Footer Buttons -->
        <div class="modal-footer">
            <button class="btn btn-outline-secondary" (click)="isSettingsOpen = false">Cancel</button>
            <button class="btn btn-primary" (click)="applySettings()">Apply</button>
        </div>
    </clr-modal>

</div>